export interface Category {
  id: string;
  name: string;
  slug: string;
  desc: string;
  count: number;
  icon: string;
  img: string;
}

export interface MangaItem {
  id: string;
  title: string;
  category: string;
  status: string;
  author: string;
  intro: string;
  cover: string;
  chapters: number;
  rating: number;
  tags: string[];
}

export interface CollectionItem {
  id: string;
  title: string;
  subtitle: string;
  count: string;
  desc: string;
  img: string;
}

export interface ArticleItem {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  read: string;
  img: string;
  content: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface TestimonialItem {
  name: string;
  role: string;
  text: string;
  avatar: string;
}

export const categories: Category[] = [
  {
    id: 'c1',
    name: '狐妖',
    slug: 'fox-spirit',
    desc: '千年修行、化形入世，或魅惑或深情，狐妖题材是妖精漫画中最经典的类别。',
    count: 236,
    icon: 'ri-fire-line',
    img: 'https://readdy.ai/api/search-image?query=A%20mystical%20white%20nine-tailed%20fox%20spirit%20with%20golden%20eyes%20in%20traditional%20Chinese%20ink%20painting%20style%2C%20floating%20cinnabar%20red%20lotus%20flowers%20and%20fog%2C%20ethereal%20rice%20paper%20background%2C%20elegant%20oriental%20fantasy%20art&width=600&height=720&seq=cat-fox-01&orientation=portrait',
  },
  {
    id: 'c2',
    name: '猫妖',
    slug: 'cat-spirit',
    desc: '傲娇灵猫、缠人猫娘，猫妖题材轻松治愈又带着神秘感，人气常年居高不下。',
    count: 198,
    icon: 'ri-moon-line',
    img: 'https://readdy.ai/api/search-image?query=A%20cute%20cat%20spirit%20yokai%20with%20twin%20tails%20in%20traditional%20Chinese%20fantasy%20ink%20art%2C%20warm%20amber%20and%20cream%20tones%2C%20paper%20lantern%20glow%2C%20soft%20rice%20paper%20background%2C%20charming%20eastern%20legend%20illustration&width=600&height=720&seq=cat-yokai-01&orientation=portrait',
  },
  {
    id: 'c3',
    name: '花妖',
    slug: 'flower-spirit',
    desc: '花开花落皆成妖，牡丹、樱、梅、莲化作人形，唯美画风配上宿命般的爱恋。',
    count: 167,
    icon: 'ri-flower-line',
    img: 'https://readdy.ai/api/search-image?query=A%20flower%20spirit%20beauty%20with%20peony%20blossoms%20in%20hair%20in%20traditional%20Chinese%20watercolor%20style%2C%20soft%20pink%20and%20cream%20palette%2C%20delicate%20petals%20falling%2C%20poetic%20eastern%20fairytale%20illustration&width=600&height=720&seq=cat-flower-01&orientation=portrait',
  },
  {
    id: 'c4',
    name: '树妖',
    slug: 'tree-spirit',
    desc: '百年老树成精，与山川草木为伴，树妖故事常带厚重的守护与轮回之意。',
    count: 121,
    icon: 'ri-tree-line',
    img: 'https://readdy.ai/api/search-image?query=A%20mossy%20tree%20spirit%20with%20ancient%20gnarled%20branches%20and%20glowing%20leaves%20in%20dark%20teal%20and%20gold%20ink%20painting%2C%20misty%20mountain%20forest%2C%20serene%20eastern%20mythology%20art&width=600&height=720&seq=cat-tree-01&orientation=portrait',
  },
  {
    id: 'c5',
    name: '雪女',
    slug: 'snow-woman',
    desc: '生于冰雪、眉目含霜，雪女题材冷冽而惊艳，是冬日题材漫画家偏爱的化身。',
    count: 86,
    icon: 'ri-snowflake-line',
    img: 'https://readdy.ai/api/search-image?query=A%20pale%20snow%20spirit%20woman%20with%20frost%20blue%20hair%20and%20falling%20snowflakes%20in%20minimal%20eastern%20ink%20wash%20style%2C%20cool%20white%20and%20steel%20teal%20tones%2C%20wintry%20dreamy%20fantasy%20portrait&width=600&height=720&seq=cat-snow-01&orientation=portrait',
  },
  {
    id: 'c6',
    name: '河童',
    slug: 'kappa',
    desc: '水岸的小妖也有大故事，河童题材轻松诙谐，常与夏日、河川、少年冒险相伴。',
    count: 73,
    icon: 'ri-water-flash-line',
    img: 'https://readdy.ai/api/search-image?query=A%20playful%20river%20kappa%20yokai%20with%20water%20lilies%20in%20cheerful%20eastern%20storybook%20style%2C%20emerald%20green%20and%20cream%20tones%2C%20gentle%20river%20background%2C%20charming%20folk%20tale%20illustration&width=600&height=720&seq=cat-kappa-01&orientation=portrait',
  },
];

export const featuredManga: MangaItem[] = [
  {
    id: 'm1',
    title: '九尾照夜录',
    category: '狐妖',
    status: '连载中',
    author: '夜岚',
    intro: '灵狐一族为守护人间灯火而踏上寻缘之路，半妖少年与九尾白狐的宿命相遇。',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manga%20cover%20of%20a%20young%20half-fox%20spirit%20boy%20and%20white%20nine-tailed%20fox%2C%20cinnabar%20red%20and%20gold%20ink%20art%2C%20moonlit%20night%20pagoda%2C%20dramatic%20eastern%20wuxia%20composition%2C%20high%20detail%2C%20clean%20minimal%20background&width=600&height=900&seq=manga-cover-01&orientation=portrait',
    chapters: 128,
    rating: 9.4,
    tags: ['热血', '东方奇幻', '人妖恋'],
  },
  {
    id: 'm2',
    title: '猫灵小茶馆',
    category: '猫妖',
    status: '已完结',
    author: '茶碗',
    intro: '一只会泡茶的猫妖在闹市开了间小茶馆，人来人往间收集人间百态与暖心故事。',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20cat%20spirit%20barista%20in%20a%20cozy%20teahouse%2C%20warm%20amber%20and%20cream%20eastern%20ink%20style%2C%20steaming%20tea%2C%20paper%20lanterns%2C%20heartwarming%20slice%20of%20life%20manga%20cover%2C%20clean%20background&width=600&height=900&seq=manga-cover-02&orientation=portrait',
    chapters: 96,
    rating: 9.1,
    tags: ['治愈', '日常', '妖怪茶馆'],
  },
  {
    id: 'm3',
    title: '牡丹花下',
    category: '花妖',
    status: '连载中',
    author: '素笺',
    intro: '被贬下凡的牡丹花妖与书生在江南烟雨中相遇，一场跨越花期的千年之恋。',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20peony%20flower%20spirit%20and%20a%20scholar%20under%20rain%20in%20jiangnan%2C%20soft%20pink%20and%20ink%20wash%20style%2C%20romantic%20eastern%20fantasy%20manga%20cover%2C%20petals%20in%20air%2C%20poetic%20moody%20composition&width=600&height=900&seq=manga-cover-03&orientation=portrait',
    chapters: 74,
    rating: 9.0,
    tags: ['古风', '虐恋', '花妖'],
  },
  {
    id: 'm4',
    title: '山灵守川',
    category: '树妖',
    status: '连载中',
    author: '青松',
    intro: '守护山川的百年树灵，为平息人间与自然之争，以己身化桥渡众生。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20tree%20spirit%20guardian%20standing%20by%20a%20mountain%20river%2C%20dark%20teal%20and%20gold%20ink%20painting%2C%20misty%20peaks%2C%20epic%20eastern%20fantasy%20manga%20cover%2C%20serene%20majestic%20composition&width=600&height=900&seq=manga-cover-04&orientation=portrait',
    chapters: 58,
    rating: 8.8,
    tags: ['守护', '自然', '东方玄幻'],
  },
  {
    id: 'm5',
    title: '霜华似水',
    category: '雪女',
    status: '已完结',
    author: '闻笛',
    intro: '北地雪女为报一饭之恩，用百年修为换一段人间温情，冷艳外壳下藏着柔软心。',
    cover: 'https://readdy.ai/api/search-image?query=Pale%20snow%20spirit%20woman%20with%20frost%20hair%20in%20white%20kimono%2C%20minimal%20eastern%20ink%20wash%2C%20cool%20blue%20white%20and%20teal%20tones%2C%20snowflakes%2C%20bittersweet%20romance%20manga%20cover%2C%20clean%20background&width=600&height=900&seq=manga-cover-05&orientation=portrait',
    chapters: 63,
    rating: 8.9,
    tags: ['虐恋', '冬日', '报恩'],
  },
  {
    id: 'm6',
    title: '河童的夏天',
    category: '河童',
    status: '连载中',
    author: '凉糕',
    intro: '一个少年捡到迷路的河童，从此开始一段关于友情、成长与夏日冒险的旅程。',
    cover: 'https://readdy.ai/api/search-image?query=Boy%20and%20playful%20kappa%20yokai%20by%20a%20sunlit%20river%2C%20emerald%20green%20and%20cream%20storybook%20style%2C%20cheerful%20summer%20adventure%20manga%20cover%2C%20water%20lilies%2C%20bright%20wholesome%20composition&width=600&height=900&seq=manga-cover-06&orientation=portrait',
    chapters: 42,
    rating: 8.7,
    tags: ['冒险', '治愈', '少年'],
  },
  {
    id: 'm7',
    title: '百妖集·灯',
    category: '百妖',
    status: '连载中',
    author: '拾灯',
    intro: '灯笼铺掌柜能看见妖怪，每盏灯都封印一段妖的故事，夜夜为其点亮归路。',
    cover: 'https://readdy.ai/api/search-image?query=Lantern%20shop%20keeper%20lighting%20a%20row%20of%20glowing%20paper%20lanterns%20each%20holding%20a%20spirit%2C%20warm%20gold%20and%20cinnabar%20ink%20art%2C%20night%20market%20atmosphere%2C%20anthology%20manga%20cover%2C%20mystical%20eastern%20tale&width=600&height=900&seq=manga-cover-07&orientation=portrait',
    chapters: 51,
    rating: 9.2,
    tags: ['志怪', '单元剧', '夜市'],
  },
  {
    id: 'm8',
    title: '灵鹿听风',
    category: '山鬼',
    status: '已完结',
    author: '鹤归',
    intro: '山林化形的小灵鹿与猎户之女的约定，在山野风中说尽人与自然相依的古老秘密。',
    cover: 'https://readdy.ai/api/search-image?query=Ethereal%20deer%20spirit%20and%20mountain%20girl%20in%20spring%20forest%2C%20soft%20green%20and%20cream%20eastern%20watercolor%2C%20sunbeams%20through%20trees%2C%20gentle%20nature%20fantasy%20manga%20cover%2C%20clean%20natural%20background&width=600&height=900&seq=manga-cover-08&orientation=portrait',
    chapters: 47,
    rating: 8.6,
    tags: ['清新', '自然', '少女'],
  },
];

export const collections: CollectionItem[] = [
  {
    id: 'col1',
    title: '狐妖漫画大全合集',
    subtitle: '九尾名作 · 情缘志怪',
    count: '236 部',
    desc: '从经典九尾狐到现代都市狐仙，一站式收录最全狐妖题材漫画，狐系粉丝不容错过。',
    img: 'https://readdy.ai/api/search-image?query=A%20row%20of%20traditional%20Chinese%20fox%20spirit%20characters%20across%20a%20scroll%20banner%2C%20cinnabar%20and%20gold%20ink%20art%2C%20clouds%20and%20pagoda%2C%20collection%20banner%20for%20a%20fox%20yokai%20manga%20hub%2C%20wide%20landscape%20layout&width=800&height=520&seq=col-fox-01&orientation=landscape',
  },
  {
    id: 'col2',
    title: '花妖漫画大全合集',
    subtitle: '花开即妖 · 宿命之恋',
    count: '167 部',
    desc: '牡丹、樱花、梅、莲各色花妖齐聚，唯美画风与动人故事并行，浪漫首选。',
    img: 'https://readdy.ai/api/search-image?query=Flower%20spirits%20of%20peony%20cherry%20and%20lotus%20gathered%20in%20a%20spring%20garden%20banner%2C%20soft%20pink%20and%20cream%20watercolor%2C%20falling%20petals%2C%20romantic%20collection%20banner%2C%20wide%20landscape%20layout&width=800&height=520&seq=col-flower-01&orientation=landscape',
  },
  {
    id: 'col3',
    title: '百妖志怪大全合集',
    subtitle: '山海异闻 · 夜话奇谭',
    count: '308 部',
    desc: '狐、猫、花、树、雪、河童……山海百妖一个不少，冷门佳作也能在这里翻到。',
    img: 'https://readdy.ai/api/search-image?query=A%20panoramic%20gathering%20of%20many%20Chinese%20yokai%20spirits%20fox%20cat%20tree%20snow%20in%20a%20night%20mountain%20banner%2C%20dark%20teal%20gold%20and%20cinnabar%20ink%20art%2C%20misty%20peaks%2C%20grand%20collection%20banner%2C%20wide%20landscape%20layout&width=800&height=520&seq=col-all-01&orientation=landscape',
  },
  {
    id: 'col4',
    title: '治愈日常妖怪合集',
    subtitle: '温暖相伴 · 人间烟火',
    count: '142 部',
    desc: '不以战斗见长，专讲人与小妖的温馨日常，疲惫时最适合点开的一部合集。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20scene%20of%20cute%20small%20yokai%20sharing%20tea%20with%20humans%20in%20a%20warm%20tea%20house%2C%20amber%20and%20cream%20storybook%20style%2C%20heartwarming%20slice%20of%20life%20collection%20banner%2C%20wide%20landscape%20layout&width=800&height=520&seq=col-heal-01&orientation=landscape',
  },
];

export const articles: ArticleItem[] = [
  {
    id: 'a1',
    title: '狐妖漫画为何长盛不衰？从九尾狐到现代狐仙的演变',
    excerpt: '狐妖题材历经千年仍被反复书写，本文梳理狐妖漫画从志怪到都市的创作脉络，帮你快速理解这个经典题材的独特魅力。',
    category: '题材解读',
    date: '2026-08-15',
    read: '8 分钟',
    img: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20fox%20spirit%20literature%20theme%20illustration%2C%20open%20ancient%20book%20with%20glowing%20nine-tailed%20fox%20rising%2C%20cinnabar%20gold%20ink%20wash%2C%20scholarly%20atmosphere%2C%20wide%20landscape%20article%20header&width=800&height=520&seq=art-fox-01&orientation=landscape',
    content: [
      '狐妖是中国志怪文化中最具生命力的形象之一。从《山海经》到《聊斋志异》，狐的形象不断在魅惑与深情之间游走，而这份张力也天然适配漫画的戏剧表达。',
      '早期狐妖漫画多取材于传统志怪，突出"修炼成精、化形入世"的设定；随着时代发展，创作者开始把狐妖融入都市、校园与职场，让古老传说在当代语境里重新焕发光彩。',
      '也正是这种"经典与创新并存"的特质，让狐妖漫画无论热门还是冷门都拥有稳定受众，成为妖精漫画大全中更新最活跃的类别之一。',
    ],
  },
  {
    id: 'a2',
    title: '入坑指南：妖精漫画新手应该从哪些作品开始看？',
    excerpt: '面对几百部妖精漫画无从下手？这份新手入坑指南按题材、画风、篇幅为你整理了一份循序渐进的选择清单。',
    category: '入坑指南',
    date: '2026-08-10',
    read: '6 分钟',
    img: 'https://readdy.ai/api/search-image?query=A%20guide%20book%20with%20a%20compass%20and%20cute%20yokai%20characters%20gathered%20around%2C%20warm%20amber%20and%20cream%20storybook%20style%2C%20beginner%20guide%20theme%2C%20wide%20landscape%20article%20header&width=800&height=520&seq=art-guide-01&orientation=landscape',
    content: [
      '新手入坑妖精漫画，最关键的是先选对题材。偏好热血可以看狐妖与山鬼系，偏好治愈可以从猫妖、河童的日常故事入手，偏好古风虐恋则绕不开花妖与雪女。',
      '篇幅上，短篇与单元剧类作品更适合快速建立阅读节奏，等逐渐熟悉题材后再挑战长篇史诗。',
      '妖精漫画大全按分类、人气、更新状态为你整理了清晰入口，无论想看热门还是冷门，都能在合集页一步到位。',
    ],
  },
  {
    id: 'a3',
    title: '花妖漫画里的中式美学：从工笔到水墨的视觉语言',
    excerpt: '花妖漫画之所以唯美动人，很大程度得益于对中式工笔与水墨技法的借鉴。这篇从画风角度聊聊花妖题材的美学密码。',
    category: '画风赏析',
    date: '2026-08-06',
    read: '5 分钟',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20with%20elegant%20peony%20and%20silk%20brush%2C%20soft%20pink%20and%20ink%20tones%2C%20artistic%20aesthetic%20analysis%20theme%2C%20wide%20landscape%20article%20header&width=800&height=520&seq=art-flower-01&orientation=landscape',
    content: [
      '花妖题材天然亲近中式美学。花瓣的层叠、枝条的留白、水色的晕染，都被漫画家转化为极具辨识度的画面语言。',
      '工笔画风的精细勾勒适合表现牡丹、芍药的雍容，水墨写意则更贴合梅、兰的清冷气质。不同花种对应不同笔触，是花妖漫画的一大看点。',
      '当我们谈论花妖漫画时，谈的不只是爱情与宿命，更是一种融入笔墨的东方审美。这也正是它区别于其他题材的核心魅力。',
    ],
  },
  {
    id: 'a4',
    title: '更新快、无需下载：在妖精漫画大全看连载的正确姿势',
    excerpt: '追更党最怕更新断档。这里分享如何利用妖精漫画大全的分类与合集入口，高效追踪你正在追的连载作品。',
    category: '使用技巧',
    date: '2026-07-30',
    read: '4 分钟',
    img: 'https://readdy.ai/api/search-image?query=A%20smartphone%20showing%20a%20manga%20reading%20app%20with%20glowing%20notification%20of%20new%20chapter%2C%20amber%20and%20teal%20tones%2C%20modern%20clean%20style%2C%20wide%20landscape%20article%20header&width=800&height=520&seq=art-tip-01&orientation=landscape',
    content: [
      '追连载最怕错过更新。妖精漫画大全为每部作品标注了连载状态与最新章节，点开即看，无需下载任何应用。',
      '善用分类与合集入口，可以将同一题材、同一作者的作品集中管理，冷门佳作也能第一时间被发现。',
      '保持书签习惯，把正在追的作品放在一起，配合每日更新的列表，追更体验会顺畅很多。',
    ],
  },
];

export const faqs: FaqItem[] = [
  {
    q: '妖精漫画大全可以在线免费看吗？',
    a: '可以的。妖精漫画大全主打免费在线看，无需下载应用，点开对应作品页面即可直接阅读，热门与冷门作品都收录其中，方便读者随时随地在网页上追更。',
  },
  {
    q: '如何找到妖精漫画大全的网站入口？',
    a: '直接进入妖精漫画大全首页即可看到全部分类。首页导航提供狐妖、猫妖、花妖、树妖、雪女、河童等类型入口，并通过合集页汇总全题材作品，找入口一步到位。',
  },
  {
    q: '妖精漫画大全的合集与全集有什么区别？',
    a: '合集按题材汇总，例如"狐妖漫画大全合集"收录全部狐妖作品；全集则指单部作品已完整更新至完结。两者结合使用，既能横向对比同题材，也能纵向看完整部故事。',
  },
  {
    q: '网站多久更新一次？',
    a: '网站保持高频更新，连载作品一旦有最新章节就会同步上架，并同步在热门推荐与各分类列表中体现，尽量缩短追更等待时间。',
  },
  {
    q: '支持手机、平板等移动设备观看吗？',
    a: '支持。妖精漫画大全采用响应式设计，在电脑、平板和手机上都能获得良好阅读体验，导航在移动端也可正常展开与收起。',
  },
  {
    q: '想看冷门题材的妖精漫画，能在这里找到吗？',
    a: '可以。除热门题材外，网站同样覆盖山鬼、百妖等相对冷门的类别，力求做到"热门冷门都能翻到"，满足不同口味的读者。',
  },
];

export const testimonials: TestimonialItem[] = [
  {
    name: '阿离',
    role: '狐妖爱好者',
    text: '找狐妖漫画找了好多年，终于在妖精漫画大全把所有经典和冷门一网打尽。分类很细，追更也很方便，入坑以来就没换过地方。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimal%20avatar%20of%20a%20smiling%20young%20woman%20with%20fox%20ears%2C%20flat%20illustration%2C%20warm%20amber%20and%20cream%20tones%2C%20clean%20background&width=200&height=200&seq=ava-01&orientation=squarish',
  },
  {
    name: '青柠',
    role: '治愈系读者',
    text: '工作累了一天就想看点治愈的。这里的猫妖、河童日常合集质量都很高，画面舒服故事温暖，真的是我的精神充电站。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimal%20avatar%20of%20a%20gentle%20girl%20with%20cat%20ears%20and%20soft%20smile%2C%20flat%20illustration%2C%20soft%20green%20and%20cream%20tones%2C%20clean%20background&width=200&height=200&seq=ava-02&orientation=squarish',
  },
  {
    name: '守鹤',
    role: '古风漫画迷',
    text: '花妖和雪女的画风审美很在线，工笔和水墨的氛围感做得很足。合集入口整理得清清楚楚，想找什么一眼就能翻到。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimal%20avatar%20of%20a%20young%20man%20with%20crane%20feather%20motif%2C%20flat%20illustration%2C%20ink%20and%20teal%20tones%2C%20clean%20background&width=200&height=200&seq=ava-03&orientation=squarish',
  },
];